// Phase 2 (Jun 2026) — regional date format flipped to MM/DD/YYYY (US locale)
// for all user-visible date displays. Internal API/DB stays ISO YYYY-MM-DD.
// This helper takes anything that looks like a date and returns "MM/DD/YYYY",
// or "—" when the value is empty/invalid.
//
// HTML5 `<input type="date">` is **not** routed through this helper — that
// control requires ISO yyyy-mm-dd as its `value` and renders the date in the
// user's browser locale via the native picker.

export function formatDate(value) {
  if (value === null || value === undefined) return "—";
  // Accept ISO timestamps, ISO dates, JS Date objects.
  let d;
  if (value instanceof Date) {
    d = value;
  } else if (typeof value === "string") {
    if (!value.trim()) return "—";
    // Strict ISO YYYY-MM-DD shortcut to avoid timezone shifting at midnight.
    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const [, y, m, dd] = isoMatch;
      return `${m}/${dd}/${y}`;
    }
    d = new Date(value);
  } else {
    return "—";
  }
  if (!d || Number.isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${mm}/${dd}/${yy}`;
}

// Formats a date+time. Used for audit-log timestamps and similar where a
// time of day is meaningful. Falls back to formatDate when only a date is
// given.
export function formatDateTime(value) {
  if (value === null || value === undefined) return "—";
  if (typeof value === "string" && !value.includes("T")) {
    return formatDate(value);
  }
  const d = value instanceof Date ? value : new Date(value);
  if (!d || Number.isNaN(d.getTime())) return "—";
  const base = formatDate(d);
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${base} ${hh}:${min}`;
}
